import Sidebar from "@/routes/_layout/nav/sidebar"
import useIsMobile from "@/hooks/use-is-mobile"
import BottomBar from "@/routes/_layout/nav/bottom-bar"
import { useRef } from "react"
import { Outlet } from "react-router-dom"

const AptLayout = ({ navs, header }) => {
  const isMobile = useIsMobile()
  const mainRef = useRef(null)
  return (
    <div
      className={`bg-gray-100 h-screen w-screen
        md:grid md:grid-cols-[180px_1fr] md:grid-rows-[60px_1fr]`}
    >
      {!isMobile && <Sidebar navs={navs} />}

      <div className="min-w-0 flex flex-col h-full md:block">
        {header}

        <main
          ref={mainRef}
          className={`
            w-full p-4 flex-1
            md:p-5 md:h-[calc(100vh-60px)] overflow-y-auto
          `}
        >
          <Outlet />
        </main>

        {isMobile && (
          <div className="z-50">
            <BottomBar mainRef={mainRef} />
          </div>
        )}
      </div>
    </div>
  )
}

export default AptLayout
